import { render, staticRenderFns } from "./BusquedaCliente2.vue?vue&type=template&id=9d6a4a82&scoped=true"
import script from "./BusquedaCliente2.vue?vue&type=script&lang=js"
export * from "./BusquedaCliente2.vue?vue&type=script&lang=js"
import style0 from "./BusquedaCliente2.vue?vue&type=style&index=0&id=9d6a4a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6a4a82",
  null
  
)

export default component.exports